namespace SP {
    export interface Notification {
        id: string;
        imageUrl: string;
        source: string;
        customer: string;
        title: string;
        description: boolean;
        date: string;
        severity: number;
    }


    export interface NotificationPageResult {
        status: number;
        msg: string;
        page: number;
        pageCount: number;
        data: Notification[];
    }
}